import React, { useRef, useEffect, useState } from "react";
import html2pdf from "html2pdf.js";
import axios from "axios";
import "../Style/MemberLadger.css";
import { useLocation } from "react-router-dom";
import {BASE_URL} from "../Apis/apiConfig";


const MemberLadger = () => {
  const ledgerRef = useRef();
  const location = useLocation();

  const initialRaw = location.state?.record?.[0] || {};
  const qs = new URLSearchParams(location.search);
  const [bills, setBills] = useState([]);
  const [receipts, setReceipts] = useState([]);

  const memberIdFromQs = qs.get("memberId") || "";
  const tableFromQs = qs.get("table") || qs.get("tableName") || "";
  const flatFromQs = qs.get("flat") || "";
  const nameFromQs = qs.get("name") || "";

  const [memberId] = useState(memberIdFromQs || initialRaw.Member_Id || "");
  const [tableName] = useState(tableFromQs || "");
  const [memberFlat] = useState(flatFromQs || initialRaw.Flat_No || "");
  const [memberName] = useState(nameFromQs || initialRaw.Member_Name || initialRaw.Flat_No || "");

  const societyName = localStorage.getItem("society") || "";
  const RegistrationNo = localStorage.getItem("societyRegNo") || "";
  const token = localStorage.getItem("token") || "";

  const [rows, setRows] = useState([]);
  const [styleContent, setStyleContent] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [opening, setOpening] = useState([]);



  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(25); 
  const pageSizeOptions = [10, 25, 50, 100, "All"];

  const pick = (obj, ...keys) => {
    for (const k of keys) {
      if (!obj) continue;
      const v = obj[k];
      if (v !== undefined && v !== null && String(v).trim() !== "") return v;
    }
    return "";
  };


  useEffect(() => {
    fetch("/Style/MemberLadger.css")
      .then((res) => res.text())
      .then(setStyleContent)
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!societyName) {
      setRows([]);
      return;
    }
    const fetchSociety = async () => {
      setLoading(true);
      setError(null);
      try {
        const url = `${BASE_URL}/api/get-society-by-admin?societyName=${encodeURIComponent(
          societyName
        )}&registrationNo=${encodeURIComponent(RegistrationNo)}`;
        const resp = await axios.get(url, { headers: token ? { Authorization: `Bearer ${token}` } : undefined });
        setRows(Array.isArray(resp.data) ? resp.data : []);
      } catch (err) {
        console.error("Error fetching society:", err);
        setError(err?.response?.data || err.message || "Unknown error");
        setRows([]);
      } finally {
        setLoading(false);
      }
    };
    fetchSociety();
  }, [societyName, RegistrationNo, token]);


  useEffect(() => {
    if (!memberName || !memberName.trim() || !societyName) return;
    const fetchRecords = async () => {
      setLoading(true);
      setError(null);
      try {
        const resp = await axios.get(`${BASE_URL}/ledger/get-opening-by-membername`, {
          headers: token ? { Authorization: `Bearer ${token}` } : undefined,
          params: { memberName: memberName.trim(), societyName },
        });
        const data = resp.data;
        if (Array.isArray(data)) {
          setOpening(data);
          console.log("opeing data "+ JSON.stringify(data))
        } else if (data && typeof data === "object") {
          if (Array.isArray(data.data)) setOpening(data.data);
          else setOpening([data]);
        } else {
          setOpening([]);
        }
      } catch (err) {
        console.error("Error fetching transactions:", err);
        setError(err?.response?.data || err.message || "Failed to fetch records");
        setOpening([]);
      } finally {
        setLoading(false);
      }
    };
    fetchRecords();
  }, [memberName, societyName, token]);

  useEffect(() => {
    const fetchBills = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(`${BASE_URL}/ledger/get-bill-by-member`, {
          headers: token ? { Authorization: `Bearer ${token}` } : undefined,
          params: { societyName: societyName, memberName: memberName },
        });
        setBills(response.data || []);
      } catch (err) {
        console.error("Error fetching bills:", err);
        setError(err?.response?.data || "Failed to fetch bills");
      } finally {
        setLoading(false);
      }
    };
    if (societyName && memberName) fetchBills();
  }, [societyName, memberName, token]);


  useEffect(() => {
    const fetchReceipts = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(`${BASE_URL}/ledger/get-recipt-by-member`, {
          headers: token ? { Authorization: `Bearer ${token}` } : undefined,
          params: { societyName: societyName, memberName: memberName },
        });
        setReceipts(response.data || []);
      } catch (err) {
        console.error("Error fetching receipts:", err);
        setError(err?.response?.data || "Failed to fetch receipts");
      } finally {
        setLoading(false);
      }
    };
    if (societyName && memberName) fetchReceipts();
  }, [societyName, memberName, token]);

  // helpers
  const fmtDate = (d) => {
    if (!d) return "";
    try {
      const dt = new Date(d);
      if (isNaN(dt)) return String(d);
      return dt.toLocaleDateString();
    } catch {
      return String(d);
    }
  };

  const fmtAmount = (v) =>
    (parseFloat(v) || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const monthFromDate = (d) => {
    if (!d) return "";
    try {
      const dt = new Date(d);
      if (isNaN(dt)) return "";
      const monthNames = [
        "January","February","March","April","May","June",
        "July","August","September","October","November","December"
      ];
      return `${monthNames[dt.getMonth()]}`;
    } catch {
      return "";
    }
  };

  const combinedRows = (() => {
    const rowsCombined = [];
    opening.forEach((o) => {
      const amount = parseFloat(pick(o, "Total", "Opening_Balance", "Opening", "Amount", "Balance")) || 0;
      rowsCombined.push({
        _type: "opening",
        date: pick(o, "Bill_Date", "Opening_Date", "Date") || "",
        dr: amount >= 0 ? amount : 0,
        cr: amount < 0 ? Math.abs(amount) : 0,
        balance: amount,
        refNo: "",
        refLabelTop: "Opening Balance",
        refLabelBottom: "",
        chequeNo: "",
        transaction_no: "",
        transaction_date: "",
      });
    });

    bills.forEach((b) => {
      const billDate = pick(b, "Bill_Date", "Date") || "";
      const billMonth = monthFromDate(billDate);
      const refNo = String(pick(b, "Bill_No", "Reference_No", "ReferenceNo") || "");
      const periodLabel = pick(b, "Bill_For") || (billMonth ? `Bill for ${billMonth}` : "");
      const refLabelTop = periodLabel || pick(b, "Narration") || "Bill";
      rowsCombined.push({
        _type: "bill",
        date: billDate,
        dr: parseFloat(pick(b, "Total_Amount", "Dr_Amount", "Maintenance_Charges") || 0) || 0,
        cr: 0,
        balance: 0,
        refNo,
        refLabelTop,
        refLabelBottom: "",
        chequeNo: pick(b, "Cheque_No", "cheque_no") || "",
        transaction_no: pick(b, "transaction_no", "transactionNo", "Instrument_No", "Instrument") || "",
        transaction_date: pick(b, "Cheque_Date", "txn_date", "Date", "Instrument") || "",
      });
    });

    receipts.forEach((r) => {
      const receiptDate = pick(r, "Receipt_Date", "Date", "txn_date", "Instrument") || "";
      const refNo = String(pick(r, "Receipt_No", "Reference_No", "ReceiptNo") || "");
      const refLabelTop = "Receipt";
      const bankName = pick(r, "bank_name", "Bank_Name", "Bank") || "";
      const narration = pick(r, "Narration", "narration", "Narration_Text") || "";
      const refLabelBottom = [bankName, narration].filter(Boolean).join(" - ");
      const chequeNo = pick(r, "cheque_no", "Cheque_No", "Instrument_No") || "";
      const transaction_no = pick(r, "transaction_no", "transactionNo", "transaction_id", "Instrument_No", "Instrument") || "";
      const transaction_date = pick(r, "txn_date", "Transaction_Date", "Cheque_Date", "Instrument", "Date") || "";

      rowsCombined.push({
        _type: "receipt",
        date: receiptDate,
        dr: 0,
        cr: parseFloat(pick(r, "Amount", "Cr_Amount") || 0) || 0,
        balance: 0,
        refNo,
        refLabelTop,
        refLabelBottom,
        chequeNo,
        transaction_no,
        transaction_date,
      });
    });
    rowsCombined.sort((a, b) => {
      if (a._type === "opening" && b._type !== "opening") return -1;
      if (b._type === "opening" && a._type !== "opening") return 1;
      const da = a.date ? new Date(a.date) : new Date(0);
      const db = b.date ? new Date(b.date) : new Date(0);
      return da - db;
    });

    let running = rowsCombined.length && rowsCombined[0]._type === "opening" ? rowsCombined[0].dr - rowsCombined[0].cr : 0;
    rowsCombined.forEach((r, idx) => {
      if (idx === 0 && r._type === "opening") {
        r.balance = running;
      } else {
        running = running + (parseFloat(r.dr) || 0) - (parseFloat(r.cr) || 0);
        r.balance = running;
      }
    });

    return rowsCombined;
  })();

  const totalDr = combinedRows.reduce((s, r) => s + (parseFloat(r.dr) || 0), 0).toFixed(2);
  const totalCr = combinedRows.reduce((s, r) => s + (parseFloat(r.cr) || 0), 0).toFixed(2);
  const finalBalance = combinedRows.length ? combinedRows[combinedRows.length - 1].balance : 0;

  const effectivePageSize = pageSize === "All" ? (combinedRows.length || 1) : Number(pageSize);
  const pageCount = Math.max(1, Math.ceil((combinedRows.length || 0) / effectivePageSize));
  const safeCurrentPage = Math.min(Math.max(1, currentPage), pageCount);
  const startIndex = (safeCurrentPage - 1) * effectivePageSize;
  const endIndex = effectivePageSize === (combinedRows.length || 1) ? combinedRows.length : startIndex + effectivePageSize;
  const paginatedRows = combinedRows.slice(startIndex, endIndex);

  useEffect(() => {
    setCurrentPage(1);
  }, [combinedRows.length, pageSize]);

  const firstRow = rows && rows.length > 0 ? rows[0] : null;
  const addressParts = firstRow
    ? [firstRow.society_address, firstRow.society_address2, firstRow.society_address3, firstRow.society_area].filter(Boolean)
    : [];
  const addressString = firstRow ? (addressParts.join(", ") || "") + (firstRow.pin_code ? ` - ${firstRow.pin_code}` : "") : "";
  const phoneString = firstRow ? (firstRow.contact_person_phone_no?.trim() || firstRow.contact_person?.trim() || "") : "";

  const handleDownloadPDF = () => {
    const element = document.createElement("div");
    element.innerHTML = `<style>${styleContent}</style>${ledgerRef.current ? ledgerRef.current.innerHTML : ""}`;
    const opt = {
      margin: 0.5,
      filename: `Unit_Wise_Ledger_${memberName || "Unit"}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };
    html2pdf().set(opt).from(element).save();
  };

  const renderPageButtons = () => {
    const buttons = [];
    const maxButtons = 7;
    let start = Math.max(1, safeCurrentPage - Math.floor(maxButtons / 2));
    let end = Math.min(pageCount, start + maxButtons - 1);
    if (end - start + 1 < maxButtons) {
      start = Math.max(1, end - maxButtons + 1);
    }
    for (let p = start; p <= end; p++) {
      buttons.push(
        <button
          key={p}
          onClick={() => setCurrentPage(p)}
          className={`page-btn ${p === safeCurrentPage ? "active" : ""}`}
          aria-current={p === safeCurrentPage ? "page" : undefined}
        >
          {p}
        </button>
      );
    }
    return buttons;
  };

  return (
    <div className="ledger-wrapper">
      <div className="ledger-actions">
        <button className="btn-download" onClick={handleDownloadPDF}>📥 Download PDF</button>
      </div>

      <div className="ledger-container" ref={ledgerRef}>
        <div className="ledger-header">
          <h1 className="ledger-main-title">{societyName || "SOCIETY NAME"}</h1>
          <div className="ledger-sub1">Registration No.: {RegistrationNo || " - "}</div>
          <div className="ledger-address">{addressString}</div>
          <div className="ledger-address">{phoneString}</div>

          <h2 className="ledger-report-title">Unit-wise General Ledger</h2>
          <div className="ledger-period">For The Year 2024-2025<br />01/04/2024 To 31/03/2025</div>

          <div className="ledger-meta">
            <div>Page 1 of 1</div>
            <div>{new Date().toLocaleDateString()}</div>
          </div>

          <div className="unit-line">
            <strong>Unit No.: {memberName || "-"}</strong>
          </div>
        </div>

        {loading && <p className="loading">Loading ledger...</p>}
        {error && <p className="error">Error: {String(error)}</p>}
        <div className="pagination-controls" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
          <div className="page-size">
            <label>
              Show{" "}
              <select
                value={pageSize}
                onChange={(e) => {
                  const val = e.target.value === "All" ? "All" : Number(e.target.value);
                  setPageSize(val);
                }}
              >
                {pageSizeOptions.map((opt) => (
                  <option key={String(opt)} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>{" "}
              entries
            </label>
          </div>

          <div className="page-nav" style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <button onClick={() => setCurrentPage((p) => Math.max(1, p - 1))} disabled={safeCurrentPage <= 1}>Prev</button>
            {renderPageButtons()}
            <button onClick={() => setCurrentPage((p) => Math.min(pageCount, p + 1))} disabled={safeCurrentPage >= pageCount}>Next</button>
            <div style={{ marginLeft: 8 }}>
              Page {safeCurrentPage} of {pageCount} ({combinedRows.length} records)
            </div>
          </div>
        </div>

        <table className="ledger-table">
          <thead>
            <tr>
              <th className="th-date">Date</th>
              <th className="col-ref">
                <div>Reference</div>
                <div className="ref-subhead-row">
                  <span className="ref-subhead-type">Type</span>
                  <span className="ref-subhead-no">No.</span>
                </div>
              </th>
              <th className="col-cheque">
                Cheque
                <span className="sub-head"><b>No. | Date</b></span>
              </th>
              <th className="th-dr">Dr Amount</th>
              <th className="th-cr">Cr Amount</th>
              <th className="th-balance">Balance</th>
            </tr>
          </thead>
          <tbody>
            {paginatedRows.length === 0 ? (
              <tr>
                <td colSpan="6" className="no-data">No ledger entries found.</td>
              </tr>
            ) : (
              paginatedRows.map((row, idx) => {
                const globalIdx = startIndex + idx;
                // opening row
                if (row._type === "opening") {
                  return (
                    <tr key={`opening-${globalIdx}`} className="ledger-row opening-row">
                      <td className="date-cell">{fmtDate(row.date)}</td>
                      <td className="ref-cell">
                        <div className="ref-inline">
                          {row.refLabelTop ? <span className="ref-label-line">{row.refLabelTop}</span> : null}
                          {row.refNo ? <span className="ref-pipe"> | </span> : null}
                          {row.refNo ? <span className="ref-no">{row.refNo}</span> : null}
                        </div>
                      </td>

                      <td className="cheque-cell">&nbsp;</td>
                      <td className="dr-cell">{fmtAmount(row.dr)}</td>
                      <td className="cr-cell">{fmtAmount(row.cr)}</td>
                      <td className="balance-cell">{fmtAmount(row.balance)} Dr</td>
                    </tr>
                  );
                }

                const isReceipt = row._type === "receipt";

                return (
                  <tr key={`row-${globalIdx}`} className="ledger-row">
                    <td className="date-cell">{fmtDate(row.date)}</td>
                    <td className="ref-cell">
                      <div className="ref-inline">
                        {row.refLabelTop ? <span className="ref-label-line">{row.refLabelTop}</span> : null}
                        {row.refNo ? <span className="ref-pipe"> | </span> : null}
                        {row.refNo ? <span className="ref-no">{row.refNo}</span> : null}
                      </div>
                      {isReceipt && row.refLabelBottom ? (
                        <div className="ref-bank">
                          <small>{row.refLabelBottom}</small>
                        </div>
                      ) : null}
                    </td>
                    <td className="cheque-cell">
                      {row.transaction_no ? <div className="small-line">{row.transaction_no}</div> : null}
                      {row.chequeNo && row.chequeNo !== row.transaction_no ? <div className="small-line">{row.chequeNo}</div> : null}
                      <div className="small-line">{fmtDate(row.transaction_date || row.transaction_date)}</div>
                    </td>

                    <td className="dr-cell">{fmtAmount(row.dr)}</td>
                    <td className="cr-cell">{fmtAmount(row.cr)}</td>
                    <td className="balance-cell">{fmtAmount(row.balance)}</td>
                  </tr>
                );
              })
            )}
            {combinedRows.length > 0 && (
              <tr className="totals-row">
                <td colSpan="3" className="totals-label">Total</td>
                <td className="totals-val">{parseFloat(totalDr).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                <td className="totals-val">{parseFloat(totalCr).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                <td className="totals-val">{fmtAmount(finalBalance)} {finalBalance >= 0 ? "Dr" : "Cr"}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MemberLadger;
